// SCR-011's routes (NAV-007 revenue page), composed into the route table by TASK-140.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { REVENUE_PATH } from "./model";
import { Revenue } from "./revenue";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-007", path: REVENUE_PATH, title: "Revenue & margin", permission: "billing:read", component: Revenue }),
];
